import React, {useState} from 'react';
import { documentIcon, StarIcon, StarBlankIcon } from '../../../../constants/icons';

const FilesNameTemplate = ({ value, data, tableManager }) => {
  const setFavorite = (item) => {
    let data = {
        item_id: item.id,
        starred_detail: item.starred_detail == 1 ? true : false
    }
    item.toggleBookMark(data);
  };
  const {
    config: {
      additionalProps: { cell: additionalProps = {} },
    },
  } = tableManager;

  const classNames = ('rgt-cell-inner rgt-text-truncate ' + (additionalProps.className || '')).trim();
  
  return (
    <div {...additionalProps} className={classNames} title={value}>
      <div className="d-flex gap-2 align-items-center mk__stu-dms-fol_action">
        <div className="grid-icons-type">{documentIcon}</div>
        <span className="text-content flex-1">{value}</span>
        <div className="favroite-doc" onClick={() => setFavorite(data)}>
          {data.starred_detail === "1" ? StarIcon : StarBlankIcon}
        </div>
      </div>
    </div>
  );
};

export default FilesNameTemplate;
